import { __rest } from "tslib";
import * as React from 'react';
import CaretDownIcon from '@patternfly/react-icons/dist/js/icons/caret-down-icon';
import { Toggle } from './Toggle';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { DropdownContext } from './dropdownConstants';
import { css } from '@patternfly/react-styles';
export var DropdownToggle = function DropdownToggle(_a) {
  var _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$parentRef = _a.parentRef,
      parentRef = _a$parentRef === void 0 ? null : _a$parentRef,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      _a$isPrimary = _a.isPrimary,
      isPrimary = _a$isPrimary === void 0 ? false : _a$isPrimary,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$onToggle = _a.onToggle,
      onToggle = _a$onToggle === void 0 ? function (_isOpen) {
    return undefined;
  } : _a$onToggle,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      _a$toggleIndicator = _a.toggleIndicator,
      ToggleIndicator = _a$toggleIndicator === void 0 ? CaretDownIcon : _a$toggleIndicator,
      splitButtonItems = _a.splitButtonItems,
      _a$splitButtonVariant = _a.splitButtonVariant,
      splitButtonVariant = _a$splitButtonVariant === void 0 ? 'checkbox' : _a$splitButtonVariant,
      ariaHasPopup = _a['aria-haspopup'],
      ref = _a.ref,
      props = __rest(_a, ["id", "children", "className", "isOpen", "parentRef", "isDisabled", "isPlain", "isPrimary", "isActive", "onToggle", "icon", "toggleIndicator", "splitButtonItems", "splitButtonVariant", 'aria-haspopup', "ref"]);

  var toggle = React.createElement(DropdownContext.Consumer, null, function (_ref) {
    var toggleTextClass = _ref.toggleTextClass,
        toggleIndicatorClass = _ref.toggleIndicatorClass,
        toggleIconClass = _ref.toggleIconClass;
    return React.createElement(Toggle, Object.assign({}, props, {
      id: id,
      className: className,
      isOpen: isOpen,
      parentRef: parentRef,
      isActive: isActive,
      isDisabled: isDisabled,
      isPlain: isPlain,
      isPrimary: isPrimary,
      onToggle: onToggle,
      "aria-haspopup": ariaHasPopup
    }, splitButtonItems && {
      isSplitButton: true,
      'aria-label': props['aria-label'] || 'Select'
    }), icon && React.createElement("span", {
      className: css(toggleIconClass)
    }, icon), children && React.createElement("span", {
      className: ToggleIndicator && css(toggleTextClass)
    }, children), ToggleIndicator && React.createElement("span", {
      className: css(!splitButtonItems && toggleIndicatorClass)
    }, React.createElement(ToggleIndicator, null)));
  });

  if (splitButtonItems) {
    return React.createElement("div", {
      className: css(styles.dropdownToggle, styles.modifiers.splitButton, splitButtonVariant === 'action' && styles.modifiers.action, isDisabled && styles.modifiers.disabled)
    }, splitButtonItems, toggle);
  }

  return toggle;
};